// eslint-disable-next-line import/prefer-default-export
export const sectionLabels = {
  'GENERAL QUESTIONS': 'issuerQuestions.status.generalQuestions',
  'INVESTMENT REQUIREMENTS': 'issuerQuestions.status.investmentRequirements',
  'INVESTMENT PROCESS': 'issuerQuestions.status.investmentProcess',
  'OFFERING DETAILS': 'issuerQuestions.status.offeringDetails',
};
